// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleOutlinedSvg
  }));
};

PlusCircleOutlined.displayName = 'PlusCircleOutlined';
export default React.forwardRef(PlusCircleOutlined);